var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-default"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"color":"#f6861f"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('HeadBar'),_c('Navbar'),_vm._t("default"),_c('FootBar'),_c('LoginNeedModal'),_c('login-need-modal',{ref:"loginNeedModal"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }